import StripeJsContainer from "./stripe_js_container"
import PaymentInfoForm from "./payment_info_form"

import { saveUserPermissions } from "shared/scripts/new_badge_button"

import "./sign_up_and_purchase.scss"
interface Props {
  onClose: () => void
  onUpgrade: () => void
  subscriptionProps: object
  target: string
}

const PurchaseModal = ({ onClose, onUpgrade, subscriptionProps, target }: Props) => {
  const subscription = subscriptionProps[target]
  const logLocationType = subscription["tier"] === "intermediate_pro" ? `intermediate_pro_checkout` : `pro_checkout`

  return (
    <StripeJsContainer>
      <div className="flexbox">
        <PaymentInfoForm
          logLocationType={logLocationType}
          productId={subscription["product_id"]}
          tier={subscription["tier"]}
          planId={subscription["plan_id"]}
          monthlyPlan={subscription["monthly_plan"]}
          yearlyPlan={subscription["yearly_plan"]}
          eligibleForTrial={subscriptionProps["eligible_for_trial"]}
          browserType={subscriptionProps["browser_type"]}
          email={subscriptionProps["email"]}
          referrerPath={window.location.href}
          subscriptionsPath={subscriptionProps["subscriptions_path"]}
          createStripeCustomerUrl={subscriptionProps["create_stripe_customer_url"]}
          initialPromoCode={subscriptionProps["initial_promo_code"]}
          onModalHandleSuccessfulSubscription={() => {
            const isProPlus = subscription["tier"] == "pro"
            const tierName = isProPlus ? "Pro+" : "Pro"
            window.appendFlash(`Upgrade complete. Welcome to IFTTT ${tierName}!`, "success")

            saveUserPermissions(subscription["tier"], {
              multi_action: { permitted: true },
              filter_code: { permitted: isProPlus },
              queries: { permitted: isProPlus },
              multi_service_account: { permitted: isProPlus },
            })
            onUpgrade()
            onClose()
          }}
          modalButtonType="new"
          renderingInsideModal={true}
          // props not used in modal mode
          subscriptionSuccessPath=""
          redirectToMobileAppOnSuccess={false}
          campaignId={null}
        />
      </div>
    </StripeJsContainer>
  )
}

export default PurchaseModal
